import apiFetch from '../apiFetch'

export default function (saleId, token, lastAccessDate, approvalRoleCode) {
  return apiFetch({ endPoint: `dossier/sale/${saleId}/approvePwk?approvalRoleCode=${approvalRoleCode}`, method: 'PUT', body: null, token: token, lastAccessDate })
}
